import React from "react";
const ProfileButton = ({ ...props }) => {
	return (
		<div className="h-3 flex items-center mr-2" {...props}>
			<img
				className="h-6 w-auto object-contain"
				src={require("../../images/profileButton.png")}
				alt="profile-button"
			/>
		</div>
	);
};

export default ProfileButton;
